module.exports = __webpack_public_path__ + "img/imgfftBL1000.2a77cf62.png";